import { render } from "./CurrencyComponent.vue?vue&type=template&id=3e1c84a1"
import script from "./CurrencyComponent.vue?vue&type=script&lang=js"
export * from "./CurrencyComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__